export default "__VITE_ASSET__BQzRX3cR__"